import { Home } from '@/views/hydrocam';

export default {
    path: '/hydrocam',
    component: () =>import('../layouts/default'),
    children: [
        { path: '', component: Home }
    ],
    meta: { requiresAuth: true }
};